import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstanceu2wrlss616lb as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Send_instance1oebf6ttzyqzk as Send_instance } from './api/CommonHooks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_authority2s3hk87lssumy as get_authority } from '../../../../../ktor-ktor-http/io/ktor/http/Url.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import { takeFrom3rd40szpqy350 as takeFrom } from '../../../../../ktor-ktor-http/io/ktor/http/URLParser.mjs';
import { isSecurex1qiiavqi0xu as isSecure } from '../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { get_authorityakhc3pgcrb9j as get_authority_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLBuilder.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { Companion_getInstance29j9s2wnmk34z as Companion_getInstance_0 } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { EventDefinition1fymk8xrdelhn as EventDefinition } from '../../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ALLOWED_FOR_REDIRECT() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return ALLOWED_FOR_REDIRECT;
}
var ALLOWED_FOR_REDIRECT;
function get_LOGGER() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return LOGGER;
}
var LOGGER;
function get_HttpResponseRedirectEvent() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpResponseRedirectEvent;
}
var HttpResponseRedirectEvent;
function get_HttpRedirect() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpRedirect;
}
var HttpRedirect;
var HttpRedirectConfigClass;
function HttpRedirectConfig() {
  if (HttpRedirectConfigClass === VOID) {
    class $ {
      constructor() {
        this.checkHttpMethod_1 = true;
        this.allowHttpsDowngrade_1 = false;
      }
    }
    initMetadataForClass($, 'HttpRedirectConfig', HttpRedirectConfig);
    HttpRedirectConfigClass = $;
  }
  return HttpRedirectConfigClass;
}
function isRedirect(_this__u8e3s4) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var tmp0_subject = _this__u8e3s4.value_1;
  return tmp0_subject === Companion_getInstance().MovedPermanently_1.value_1 || tmp0_subject === Companion_getInstance().Found_1.value_1 || (tmp0_subject === Companion_getInstance().TemporaryRedirect_1.value_1 || (tmp0_subject === Companion_getInstance().PermanentRedirect_1.value_1 || tmp0_subject === Companion_getInstance().SeeOther_1.value_1)) ? true : false;
}
function HttpRedirectConfig$_init_$ref_rhym9t() {
  return constructCallableReference(() => new (HttpRedirectConfig())(), 0, 0, 219, '<init>');
}
function HttpRedirect$lambda($this$createClientPlugin) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var checkHttpMethod = $this$createClientPlugin.pluginConfig_1.checkHttpMethod_1;
  var allowHttpsDowngrade = $this$createClientPlugin.pluginConfig_1.allowHttpsDowngrade_1;
  var tmp = Send_instance;
  $this$createClientPlugin.on_z1oiz_k$(tmp, HttpRedirect$lambda$slambda(checkHttpMethod, allowHttpsDowngrade, $this$createClientPlugin));
  return Unit_instance;
}
function *invoke$handleCall(_this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion) {
  var call = origin;
  var requestBuilder = context;
  while (true) {
    var previousProtocol = call.get_request_jdwg4m_k$().get_url_18iuii_k$().protocol_1;
    var previousAuthority = get_authority(call.get_request_jdwg4m_k$().get_url_18iuii_k$());
    if (!isRedirect(call.get_response_xlk07e_k$().get_status_jnf6d7_k$()))
      return call;
    var location = call.get_response_xlk07e_k$().get_headers_ef25jx_k$().get_6bo4tg_k$('Location');
    if (location == null) {
      get_LOGGER().warn_mz9voc_k$('Location header missing from redirect response ' + call.get_request_jdwg4m_k$().get_url_18iuii_k$().toString() + '; returning response as is');
      return call;
    }
    client.monitor_1.raise_3e7w7u_k$(get_HttpResponseRedirectEvent(), call.get_response_xlk07e_k$());
    // Inline function 'io.ktor.util.logging.trace' call
    var this_0 = get_LOGGER();
    if (get_isTraceEnabled(this_0)) {
      var tmp$ret$1 = 'Received redirect response to ' + location + ' for request ' + call.get_request_jdwg4m_k$().get_url_18iuii_k$().toString();
      this_0.trace_fti9bv_k$(tmp$ret$1);
    }
    // Inline function 'kotlin.apply' call
    var this_1 = new (HttpRequestBuilder())();
    this_1.takeFromWithExecutionContext_gp1ep9_k$(requestBuilder);
    this_1.url_1.parameters_1.clear_j9egeb_k$();
    takeFrom(this_1.url_1, location);
    if (!allowHttpsDowngrade && isSecure(previousProtocol) && !isSecure(this_1.url_1.get_protocol_mv93kx_k$())) {
      // Inline function 'io.ktor.util.logging.trace' call
      var this_2 = get_LOGGER();
      if (get_isTraceEnabled(this_2)) {
        var tmp$ret$5 = 'Blocked redirect from ' + call.get_request_jdwg4m_k$().get_url_18iuii_k$().toString() + ' to ' + location + ' due to HTTPS downgrade';
        this_2.trace_fti9bv_k$(tmp$ret$5);
      }
      return call;
    }
    if (!(previousAuthority === get_authority_0(this_1.url_1))) {
      this_1.headers_1.remove_6241ba_k$('Authorization');
      // Inline function 'io.ktor.util.logging.trace' call
      var this_3 = get_LOGGER();
      if (get_isTraceEnabled(this_3)) {
        var tmp$ret$7 = 'Removing Authorization header for cross-authority redirect: ' + (previousAuthority + ' -> ' + this_1.url_1.buildString_xr87oh_k$());
        this_3.trace_fti9bv_k$(tmp$ret$7);
      }
    }
    requestBuilder = this_1;
    call = yield* _this__u8e3s4.proceed_g307xy_k$(requestBuilder, $completion);
  }
}
function HttpRedirect$lambda$slambda($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin) {
  return constructCallableReference(($this$on, request, $completion) => orPromise($completion, function *($completion) {
    var origin = yield* $this$on.proceed_g307xy_k$(request, $completion);
    var tmp;
    if ($checkHttpMethod && !get_ALLOWED_FOR_REDIRECT().contains_aljjnj_k$(origin.get_request_jdwg4m_k$().get_method_gl8esq_k$())) {
      return origin;
    }
    return yield* /*#__NOINLINE__*/invoke$handleCall($this$on, request, origin, $allowHttpsDowngrade, $this_createClientPlugin.client_1, $completion);
  }), 2);
}
var properties_initialized_HttpRedirect_kt_klj746;
function _init_properties_HttpRedirect_kt__ure7fo() {
  if (!properties_initialized_HttpRedirect_kt_klj746) {
    properties_initialized_HttpRedirect_kt_klj746 = true;
    ALLOWED_FOR_REDIRECT = setOf([Companion_getInstance_0().Get_1, Companion_getInstance_0().Head_1]);
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpRedirect');
    HttpResponseRedirectEvent = new (EventDefinition())();
    var tmp = HttpRedirectConfig$_init_$ref_rhym9t();
    HttpRedirect = createClientPlugin('HttpRedirect', tmp, HttpRedirect$lambda);
  }
}
//region block: exports
export {
  get_HttpRedirect as get_HttpRedirect1lgx3wewnhrb0,
};
//endregion

//# sourceMappingURL=HttpRedirect.mjs.map
